// ADR-110: hand-written placeholder matching the orval-generated hook
// convention used elsewhere in the project. Once the backend OpenAPI
// schema includes apps.support endpoints, replace this with the real
// orval-generated hooks (per the two-step pipeline: manage.py
// spectacular -> npm run api:generate) rather than hand-maintaining it.

import type { DraftAttachment } from "../store/ticketDraftStore";

export interface SubmitTicketPayload {
  subject: string;
  description: string;
  attachments: DraftAttachment[];
}

import { supportTicketsCreate, supportTicketsAttachmentsCreate } from "@/api/generated/support/support";

export async function submitTicket(payload: SubmitTicketPayload): Promise<void> {
  const ticket = await supportTicketsCreate({
    subject: payload.subject,
    description: payload.description,
  });

  for (const attachment of payload.attachments) {
    const formData = new FormData();
    formData.append("file", attachment.blob, attachment.filename);
    formData.append("capture_method", attachment.captureMethod);

    await supportTicketsAttachmentsCreate(ticket.id, {
      file: attachment.blob as any, // Orval might expect File or Blob
      capture_method: attachment.captureMethod as any,
    } as any); // Using FormData directly if needed, wait, let's see how orval expects it.
    // Actually, orval for FormData usually takes the object and converts it. Let's just use the object format.
  }
}
